// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605250200/js/" + chunkId + "." + {"44":"f24ce935","225":"d484e0a0","481":"9765a8da","486":"8f42594b","770":"3e3789e2"}[chunkId] + ".0.8196700671481892.chunk.js";
};